import { Elements } from "@stripe/react-stripe-js";
import { Stripe } from "@stripe/stripe-js";
import StripeCheckout from "components/StripeCheckout";


interface PaymentFormProps {
  stripePromise: Promise<Stripe | null>;
  creditPlanId: number;
  amount: number;
  isAutoPurchase: boolean;
  autoPurchaseCreditPlanId: number;
  autoPurchaseCreditLimit: number;
  isMonthlyPurchase: boolean;
  monthlyPurchaseCreditPlanId: number;
  onClose: () => void;
  onBack: () => void;
  onPaymentSuccess: () => void;
}

const PaymentForm = ({
  stripePromise,
  creditPlanId,
  amount,
  isAutoPurchase,
  autoPurchaseCreditPlanId,
  autoPurchaseCreditLimit,
  isMonthlyPurchase,
  monthlyPurchaseCreditPlanId,
  onClose,
  onBack,
  onPaymentSuccess,
}: PaymentFormProps) => {
  return (
    <Elements stripe={stripePromise}>
      <StripeCheckout
        creditPlanId={creditPlanId}
        amount={amount}
        isAutoPurchase={isAutoPurchase}
        autoPurchaseCreditPlanId={autoPurchaseCreditPlanId}
        autoPurchaseCreditLimit={autoPurchaseCreditLimit}
        isMonthlyPurchase={isMonthlyPurchase}
        monthlyPurchaseCreditPlanId={monthlyPurchaseCreditPlanId}
        currency="usd"
        onClose={onClose}
        onBack={onBack}
        onPaymentSuccess={onPaymentSuccess}
      />
    </Elements>
  );
};

export default PaymentForm;